import { render, staticRenderFns } from "./PaygeTransferInformation.vue?vue&type=template&id=29775115&scoped=true&"
import script from "./PaygeTransferInformation.vue?vue&type=script&lang=js&"
export * from "./PaygeTransferInformation.vue?vue&type=script&lang=js&"
import style0 from "./PaygeTransferInformation.vue?vue&type=style&index=0&id=29775115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29775115",
  null
  
)

export default component.exports